import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./app/App";
import { AuthProvider } from "./app/AuthContext";
import "./styles/global.css";

const productionHost = "allistamo-express.elmonet.fi";
const legacyStaticWebAppHost = "proud-pebble-0526f9f03.7.azurestaticapps.net";

if (window.location.hostname === legacyStaticWebAppHost) {
  window.location.replace(
    `https://${productionHost}${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
} else {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: false } }
  });

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter><AuthProvider><App /></AuthProvider></BrowserRouter>
      </QueryClientProvider>
    </StrictMode>
  );
}
